import React, {useCallback, useEffect, useMemo, useRef, useState,} from 'react';
import {AgGridReact} from '@ag-grid-community/react';
import '@ag-grid-community/styles/ag-grid.css';
import "@ag-grid-community/styles/ag-theme-alpine.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import '../../../component/css/agGridGraph.css';
import axios from "axios";
import {API_EQUIPAGE_LIST} from "../../../service/api.endpoint";
import {Loader} from '@consta/uikit/LoaderCanary';
import {company} from "../../../component/header.cmp";
import moment from "moment";

const GridEquipageEquipageList: React.FC = () => {
    const gridRef = useRef<any>();
    const [rowData, setRowData] = useState<any>();
    const [isLoading, setIsLoading] = useState(false);
    const columnDefs = [
        {
            field: 'id',
            headerName: 'id',
            hide: true
        },
        {
            field: 'created_at',
            headerName: 'Добавлен',
            width: 150,

        },
        {
            field: 'name',
            headerName: 'Гос. номер',
            flex: 1,
            minWidth: 140,
            sortable: true,
            filter: true,
            resizable: true,

        },
    ];

    const getRowId = useMemo(() => {
        return (params: any) => {
            return params.data.pk
        };
    }, []);

    const defaultColDef = useMemo(() => {
        return {
            // width: 120,
            sortable: true,
            resizable: true,
            suppressHeaderContextMenu: true,
        };
    }, []);


    const fetchData = async () => {
        try {
            // console.time("fetchData"); // Засекаем время выполнения
            const response = await axios.get(API_EQUIPAGE_LIST, {params: {company: company}});
            // console.timeEnd("fetchData"); // Выводим время выполнения в консоль

            return response.data.map((item: any) => {
                const formattedDate = moment(item.created_at).format('DD.MM.YYYY HH:mm');
                return {...item, created_at: formattedDate};
            })
        } catch (error) {
            console.log(error);
            return []
        } finally {
            setIsLoading(false);
        }
    };

    const onGridReady = async (params: any) => {
        // const data = await fetchData()
        setRowData(await fetchData())
    };

    useEffect(() => {
        setIsLoading(true)
        onGridReady(null); // Вызываем функцию при монтировании компонента
    }, []);

    const statusBar = useMemo(() => {
        return {
            statusPanels: [
                {statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left'},
            ],
        };
    }, []);

    const onFirstDataRendered = useCallback((params: any) => {
        gridRef.current.api.sizeColumnsToFit();
    }, []);

    return (
        <div className="equipage-list-card">
            <div className="ag-theme-alpine equipage-list-grid">
                {isLoading && !rowData && (
                    <div className="equipage-grid-loader">
                        <Loader/>
                    </div>
                )}
                <AgGridReact
                    ref={gridRef}
                    rowData={rowData || []}
                    columnDefs={columnDefs}
                    animateRows={true}
                    getRowId={getRowId}
                    defaultColDef={defaultColDef}
                    onGridReady={onGridReady}
                    statusBar={statusBar}
                    onFirstDataRendered={onFirstDataRendered}
                />
            </div>
        </div>
    );
};

export default GridEquipageEquipageList;
